import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { ReportType } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteReportType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("report-types", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Report Type Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.REPORT_TYPES,
        (reportTypes: ReportType[] | undefined) => {
          return !reportTypes
            ? []
            : deleteEntity<ReportType>(reportTypes, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Report Type Deleting Error", { variant: "error" });
    },
  });
};
